import React, { useEffect, useState } from "react";
import { Form, Dropdown, Button, Message } from "semantic-ui-react";
import { AdminAuth } from "../../../../api";

const adminAuthController = new AdminAuth();

/**
 * Paso 2 del flujo 2FA admin: selección de superadministrador autorizado
 * que recibirá el OTP por correo.
 */
export function AdminSuperuserSelect({
  pendingAdminToken,
  onOtpSent,
  onCancel,
}) {
  const [superusers, setSuperusers] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoadingList(true);
    adminAuthController
      .fetchSuperAdmins(pendingAdminToken)
      .then((list) => {
        if (cancelled) return;
        setSuperusers(list || []);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || "No se pudo obtener la lista de superadmins.");
      })
      .finally(() => {
        if (!cancelled) setLoadingList(false);
      });
    return () => {
      cancelled = true;
    };
  }, [pendingAdminToken]);

  const handleSend = async () => {
    if (!selectedEmail) return;
    setSending(true);
    setError(null);
    try {
      const otpToken = await adminAuthController.sendOtp(
        pendingAdminToken,
        selectedEmail,
      );
      onOtpSent({ otpToken, email: selectedEmail });
    } catch (err) {
      setError(err.message || "No se pudo enviar el código. Intenta de nuevo.");
    } finally {
      setSending(false);
    }
  };

  const options = superusers.map((s) => ({
    key: s.email,
    text: s.displayName ? `${s.displayName} — ${s.email}` : s.email,
    value: s.email,
  }));

  return (
    <div className="auth-step">
      <h2 className="auth-step__title">Verificación en dos pasos</h2>
      <p className="auth-step__subtitle">
        Selecciona el superadministrador que recibirá el código de acceso por
        correo.
      </p>

      {error && (
        <Message negative size="small">
          {error}
        </Message>
      )}

      <Form onSubmit={(e) => e.preventDefault()}>
        <Form.Field>
          <Dropdown
            placeholder="Selecciona un superadministrador"
            fluid
            search
            selection
            loading={loadingList}
            disabled={loadingList || sending}
            options={options}
            value={selectedEmail}
            onChange={(_, { value }) => setSelectedEmail(value)}
          />
        </Form.Field>

        <Button
          type="button"
          primary
          fluid
          loading={sending}
          disabled={!selectedEmail || sending}
          onClick={handleSend}
        >
          Enviar código
        </Button>

        <hr className="auth-step__divider" />

        <Button type="button" basic fluid onClick={onCancel} disabled={sending}>
          Cancelar y volver al inicio
        </Button>
      </Form>
    </div>
  );
}
